import { Injectable, Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
    name: 'SortByTimeStampPipe',
    standalone: false
})
export class SortByTimeStampPipe implements PipeTransform {
    constructor() { }
    transform(items: any, args?: any): any {
        const dateStampKey = args || 'createDate';
        return items.sort((a: any, b: any) => {
            return new Date(b[dateStampKey]).getTime() - new Date(a[dateStampKey]).getTime();
        });
    }
}
